import styled, { css } from 'styled-components';
import palette from 'lib/styles/palette';
import ReactLoading from 'react-loading';

const Loading = ({ padding, marginTop, small, ...rest }) => (
  <LoadingBlock padding={padding} marginTop={marginTop} {...rest}>
    <ReactLoading
      type="spin"
      color={palette.theme[3]}
      height={small ? 20 : 50}
      width={small ? 20 : 50}
    />
  </LoadingBlock>
);

export default Loading;

const LoadingBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${props =>
    props.padding &&
    css`
      padding: 3rem 0;
    `}
  ${props =>
    props.marginTop &&
    css`
      margin-top: 3rem;
    `}
`;
